export default __webpack_public_path__ + "static/media/regeneraTwitter-600x314.2d53a4d6.jpg";